export default __webpack_public_path__ + "static/media/publicidad01.bf1cb87c.jpg";